import { LegislativnyMaterialSledovanieApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import Uuid from '../../../model/Uuid';
import { ClientResponse } from '../../../model/ClientResponse';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';

const client = new LegislativnyMaterialSledovanieApi(apiConfiguration(evidenciaPrefixPath));

export const addSledovatel = async (materialId: Uuid, headers?: object): Promise<ClientResponse<void>> => {
  const { status } = await client.addSledovatel(materialId, headers);
  return {
    responseCode: status,
  };
};

export const deleteSledovatel = async (materialId: Uuid, headers?: object): Promise<ClientResponse<void>> => {
  const { status } = await client.deleteSledovatel(materialId, headers);
  return {
    responseCode: status,
  };
};
